<template>
  <div>
    <b-navbar toggleable="lg" style="background-color: #fcc727">
      <b-navbar-brand
          style="cursor:pointer;"
          @click="handleChangeViewState('plan')"
      >
        Living Care Plan
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
              :active="viewState=='apps'"
              @click="handleChangeViewState('apps')"
          >
            <b-icon
                icon="ui-checks-grid"
            />
            MyApps
          </b-nav-item>
          <b-nav-item
              @click="handleChangeViewState('calendar')"
              :active="viewState=='calendar'"
          >
            <b-icon
                icon="calendar"
            />
            Calendar
          </b-nav-item>
          <b-nav-item href="#" disabled>
            <b-icon
                icon="telephone"
            />
            Communicate
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-button size="md"
                    variant="dark"
                    class="mb-2"
          >
            <b-icon icon="printer" aria-label="Print"/>
            Print
          </b-button>

          <b-button size="md"
                    variant="dark"
                    class="mb-2"
                    style="margin-left: 10px"
                    @click="handleGeneratePlan"
          >
            <b-icon icon="flower1"
                    aria-label="Generate"/>
            Generate
          </b-button>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <body-apps
        v-if="viewState == 'apps'"
        :apps="apps"
        :profile="profile"
        :heartbeat="heartbeat"
    />
    <shared-calendar
        v-else-if="viewState == 'calendar'"
        :apps="apps"
        :profile="profile"
        :heartbeat="heartbeat"
    />
    <div v-else-if="viewState== 'generate'" class="text-center">
        <b-spinner
            style="margin-top: 50px;"
            variant="primary"
            type="grow"
            label="Loading..."
        />
      <h3>Please wait as we generate your Care Plan</h3>
    </div>
    <living-care-plan
        v-else
        :apps="apps"
        :profile="profile"
        :heartbeat="heartbeat"
        :form-prompt="formPrompt"
        @input-answer="handleInputAnswer"
    />
    <h3 style="color: red" >
      <div v-for="(anError, i) in formErrors" :key="`err_${i}`">
        {{anError}}
      </div>
    </h3>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import BodyApps from "./bodyApps";
import LivingCarePlan from "./livingCarePlan";
import SharedCalendar from "./calendar";
import firebase from "firebase";
export default {
  name: "HeartBeat_MainSection",
  components: {
    BodyApps,
    LivingCarePlan,
    SharedCalendar
  },
  created() {
    this.formReset();
  },
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    profile: {
      type: Object,
      required: true,
      default: () => {}
    },
    apps: {
      type: Array,
      required: true,
      default: () => {return []}
    },
  },
  computed: {
    ...mapGetters({}),
    uidHeartBeat(){
      return  this.heartbeat && this.heartbeat.uid ? this.heartbeat.uid : null;
    },
    uidFam(){
      return this.profile && this.profile.userId ? this.profile.userId: null;
    },
    nameHeartBeat(){
      return this.heartbeat && this.heartbeat.name ? this.heartbeat.name : 'None';
    },
    nameFam(){
      return this.profile && this.profile.firstname ? this.profile.firstname : 'None';
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        session: this.session
      };
    }
  },
  methods: {
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile ? `${this.profile.firstname} ${this.profile.lastname}` : null,
        imgURL:  this.profile ? this.profile.imgURL : null
      };
    },
    handleChangeViewState(newViewState){
      this.viewState = newViewState;
    },
    handleInputAnswer(answKV){
      this.formPrompt[answKV.key]= answKV.value;
    },
    handleGeneratePlan() {
      //Verify that questions are answered
      //Pause all Tabs
      //hide message Box with Iona
      //Pull from Health Data on the phone
      this.simpleValidate();
      if (Array.isArray(this.formErrors) && this.formErrors.length == 0 ) {
        this.handleChangeViewState('generate');
        this.handleSubmitPlan();
      }
    },
    async handleSubmitPlan(){
      debugger;
      if ( this.formPrompt && this.uidHeartBeat && this.uidFam ) {
        let profileBy = this.profileBy();

        const ref = await firebase
            .firestore()
            .collection(`users/${this.uidHeartBeat}/heartbeat/plans/${this.uidFam}`)
            .add({
              _created_at: new Date(),
              _created_by: profileBy,
              heartbeat: this.nameHeartBeat,
              fam: this.nameFam,
              relation:"grandson",
              answer_situation: this.formPrompt['answer_situation'],
              answer_symptoms: this.formPrompt['answer_symptoms'],
              answer_issues_aad: this.formPrompt['answer_issues_aad'],
              answer_adl: this.formPrompt['answer_adl'],
            }); // Include values for { unspecified parameter } fields

        ref.onSnapshot(snap => {
          if (snap.get('output')) {
            console.log(
                'RESPONSE:',
                snap.get('output')
            );
            this.handleChangeViewState('plan');
          }
        })
      }
    },
    simpleValidate() {
      this.formErrors = [];
    },
    formReset() {
      this.formPrompt = null;
      this.formPrompt = _.clone(this.formPromptDefault);
    },
  },
  data() {
    return {
      formPrompt:null,
      formPromptDefault: {
        answer_situation: null,
        answer_symptoms: null,
        answer_issues_aad: null,
        answer_adl: null
      },
      formErrors: [],
      viewState: 'plan', //plan|apps|calendar
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>